import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="form-circle" maskId="round-filled-radius-1-stroke-1.5-IconFormCircle"><circle cx="12" cy="12" r="10" fill="currentColor"/></CentralIconBase>;
});

export default IconFormCircle;
